import { render } from "./ClubProfilePage.vue?vue&type=template&id=624710b8&scoped=true"
import script from "./ClubProfilePage.vue?vue&type=script&lang=js"
export * from "./ClubProfilePage.vue?vue&type=script&lang=js"

import "./ClubProfilePage.vue?vue&type=style&index=0&id=624710b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624710b8"]])

export default __exports__